import { UseFormReturn } from "react-hook-form";
import { AppContextProps } from "../../../libs/app-core/AppContext";
import { Toast } from "../../../libs/app-core/Toast";
import { UiMeta } from "../FrmSpwkQuestV3/UiMeta";
import { UiMetaTable } from "../FrmSpwkQuestV3/UiMetaTable";

export class ValueChangedListener {


  static OnWatch(ctx: AppContextProps, _UiMetaTable: UiMetaTable | undefined, rhf: UseFormReturn<any, any>, all_rhf_value: any, rhf_name: string | undefined, event_type: string | undefined) {

    //#region Guard Conditions... return
    if (rhf_name == null) {
      return;
    }

    if (_UiMetaTable == null) {
      return;
    }
    let metas: UiMeta[] = _UiMetaTable.FilterMetas_ByRhfName(rhf_name);// 多選 可能分散在多個題目中

    if (metas.length === 0) {
      Toast.ShowWarning(ctx, "找不到對應的 meta !? " + rhf_name);
      return;
    }
    //#endregion

    for (const meta of metas) {
      if (meta.Is單選題目()) {
        單選題_清除未勾選選項的Inputs(_UiMetaTable, meta, rhf, rhf_name, ctx);

      } else if (meta.Is多選選項()) {
        多選題_清除未勾選選項的Inputs(_UiMetaTable, meta, rhf, rhf_name, ctx);

        多選題_勾任意選項_則_清空無(_UiMetaTable, meta, rhf, rhf_name, ctx);

        多選題_勾選無_則_清空其他選項(_UiMetaTable, meta, rhf, rhf_name, ctx);
      }
    }

  }

}

function 單選題_清除未勾選選項的Inputs(_UiMetaTable: UiMetaTable, meta: UiMeta, rhf: UseFormReturn<any, any>, rhf_name: string, ctx: AppContextProps) {

  let question_value = rhf.getValues(rhf_name);// 單選題的答案

  // 所有此題相關的 Inputs
  let input_metas: UiMeta[] = _UiMetaTable.FilterInputMetas_ByQuestionGuid(meta.question_guid);

  for (const input_meta of input_metas) {
    if (input_meta.option_code !== question_value) {// UF 非勾選的答案
      rhf.setValue(input_meta.rhf_name, "");// 清除 Input 內容
    }
  }
}



function 多選題_勾任意選項_則_清空無(_UiMetaTable: UiMetaTable, meta: UiMeta, rhf: UseFormReturn<any, any>, rhf_name: string, ctx: AppContextProps) {
  let check = rhf.getValues(meta.rhf_name);

  if (check === true && meta.Is多選_無() === false) {// 如果 此項目有勾選，且不是選項 "無"
    let option_metas = _UiMetaTable.FilterOptionMetas_ByQuestionGuid(meta.question_guid);
    for (const option_meta of option_metas) {
      if (option_meta.Is多選_無()) {
        let check_無 = rhf.getValues(option_meta.rhf_name);
        if (check_無) {
          rhf.setValue(option_meta.rhf_name, false);// 找到 "無"，且有勾選--> 則 取消勾選 無
        }
      }
    }
  }

}

function 多選題_勾選無_則_清空其他選項(_UiMetaTable: UiMetaTable, meta: UiMeta, rhf: UseFormReturn<any, any>, rhf_name: string, ctx: AppContextProps) {
  let check = rhf.getValues(meta.rhf_name);

  if (check === true && meta.Is多選_無() === true) {// 如果勾選了"無"
    let option_metas = _UiMetaTable.FilterOptionMetas_ByQuestionGuid(meta.question_guid);
    for (const option_meta of option_metas) {
      if (option_meta.Is多選_無() === false) {// 對所有非 "無" 的選項...
        let check = rhf.getValues(option_meta.rhf_name);
        if (check) {
          rhf.setValue(option_meta.rhf_name, false);// 有勾的都改成沒勾
        }
      }
    }
  }

}



function 多選題_清除未勾選選項的Inputs(_UiMetaTable: UiMetaTable, meta: UiMeta, rhf: UseFormReturn<any, any>, rhf_name: string, ctx: AppContextProps) {

  let check = rhf.getValues(meta.rhf_name);

  if (check !== true) {// 如果未勾選

    // 此多選 選項 底下的 Inputs
    let input_metas = _UiMetaTable.FilterInputMetas_ByOptionGuid(meta.option_guid);

    for (const input_meta of input_metas) {
      let ori_input_value = rhf.getValues(input_meta.rhf_name);
      if (ori_input_value != null && ori_input_value !== "") {// 未清空的
        rhf.setValue(input_meta.rhf_name, "");// 都清空
      }
    }

  }
}
